import Icon from '../components/Icon.vue'

Icon.register({
  building: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 480c6.6 0 12 5.4 12 12v20h-448v-20c0-6.6 5.4-12 12-12h20v-456c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v456h20zM128 76v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM128 172v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM180 320c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40zM256 480v-84c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84h64zM320 308v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zM320 212v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zM320 116v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/building.js
// module id = 1126
// module chunks = 0